// @flow
import React from "react";
import { useTranslation } from 'react-i18next';

import {
    MenuItem,
    TextField,
} from '@material-ui/core';

import TYPES from 'Assets/json/TypesOeuvre.json'


export type Props = {
    value?: number,
    onChange?: (value: number) => any
}
export default ({ value, onChange, ...props }: Props) => {

    const { i18n } = useTranslation();

    const valueIsValid = TYPES.find(el => el.value === value) !== undefined;

    return (
        <TextField
            {...props}
            size="small"
            select
            variant='outlined'
            defaultValue={0}
            value={valueIsValid ? value : 0}
            onChange={e => {
                onChange && onChange(parseInt(e.target.value, 10))
            }}
        >
            <MenuItem value={0}></MenuItem>
            {TYPES.map(option => (
                <MenuItem key={option.value} value={option.value}>
                    {(option.loc && option.loc[i18n.language]) || ""}
                </MenuItem>
            ))}
        </TextField>
	)
};